// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDd6ZPj_nW6_OZZv_xk2D1DIGsk_UQxWeA",
  authDomain: "xdxfarmer.firebaseapp.com",
  projectId: "xdxfarmer",
  storageBucket: "xdxfarmer.firebasestorage.app",
  messagingSenderId: "607132149151",
  appId: "1:607132149151:web:f73afcb70db2ba7dc3c9aa",
  measurementId: "G-WP6H3T4FWE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app